import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProjectManagementPage } from '../components/ProjectManagementPage';
import { employeeService } from '../services/employeeService';
import { orderService } from '../services/orderService';
import { projectService } from '../services/projectService';
import { wbsService } from '../services/wbsService';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/projects')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({ to: '/project-settings/employee-project-models' });
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context;
    await Promise.all([
      queryClient.prefetchQuery({
        queryKey: ['projects'],
        queryFn: () => projectService.getProjects(),
        staleTime: 1000 * 60 * 5,
      }),
      queryClient.prefetchQuery({
        queryKey: ['orders'],
        queryFn: () => orderService.getOrders(),
        staleTime: 1000 * 60 * 5,
      }),
      queryClient.prefetchQuery({
        queryKey: ['wbs'],
        queryFn: () => wbsService.getWbs(),
        staleTime: 1000 * 60 * 5,
      }),
      queryClient.prefetchQuery({
        queryKey: ['employees'],
        queryFn: employeeService.getEmployees,
        staleTime: 1000 * 60 * 5,
      }),
    ]);
  },
  component: SettingsProjectsComponent,
});

function SettingsProjectsComponent() {
  return <ProjectManagementPage />;
}
